enum ContentType {
  GENERAL = 'GENERAL',
  VERSIONS = 'VERSIONS',
  SUPPORT = 'SUPPORT',
}

export default ContentType;
